<template>
    <div id="iodataBox">        
        <div class="searchWrap">
            <div class="row" style="width:100%">            
                <div class="itemWrap">      
                    <label>行政區：</label>              
                    <DistSelection  v-model="selectedAreaValue"  width="15%"  @area-change="handleAreaChange" />
                    <el-input v-model="keyword" placeholder="公司名稱 / 統一編號" style="width:15%;margin-right:15px;" clearable></el-input>                    
                    <el-button style="margin-right: 20px;" type="primary" icon="el-icon-search" @click="doSearch">查詢</el-button>
                    <a href="#" style="margin-right: 20px; white-space: nowrap;" @click="doClearQuery"><i style="margin-right: 5px;" class="el-icon-delete"></i>清空條件</a>   
                </div>
            </div>              
            <div class="row" style="width:100%">
                <div class="itemWrap" >
                    <label>登記日期：</label>
                    <el-date-picker :editable="true" type="daterange" value-format="yyyy-MM-dd" range-separator="至" 
                        style="width:20%"
                        start-placeholder="開始日期" 
                        end-placeholder="結束日期"
                        v-model="rangeDate"
                    ></el-date-picker>                    
                    <label style="margin-left: 10px;">進口資格：</label>
                    <el-select v-model="IsImport" placeholder="請選擇" style="width: 100px;" clearable>
                        <el-option label="全部" value="全部"></el-option>
                        <el-option label="有" value="有"></el-option>
                        <el-option label="無" value="無"></el-option>
                    </el-select>
                    <label style="margin-left: 10px;">出口資格：</label>
                    <el-select v-model="IsExport" placeholder="請選擇" style="width: 100px;" clearable>
                        <el-option label="全部" value="全部"></el-option>
                        <el-option label="有" value="有"></el-option>
                        <el-option label="無" value="無"></el-option>
                    </el-select>                                                                                              
                </div>  
            </div>

            <!-- <div class="rowTag">
                <div class="itemWrap">
                    <el-tag :key="tag" class="tagsClass" v-for="tag in lstQuery" type="success" closable :disable-transitions="false" @close="handleClose(tag)">
                            {{tag}}
                    </el-tag>
                </div>                
            </div>           -->
        </div>   
        <div class="content" style="margin-top:20px;">
            <el-table ref="multipleTable" border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" style="width: 100%"  empty-text="暫無數據" :data="tableData" @select="handleSelectionChange">              
              <el-table-column label="統一編號"  prop="UniComNm" min-width="10%">
                    <template slot-scope="scope">   
                        <el-tooltip content="將開啟新頁" placement="top">
                        <a class="goDetailPage" @click="doShowCompanyDetail(scope.row)">{{ scope.row.UniComNm }}</a>
                        </el-tooltip>    
                    </template>                                
              </el-table-column>                              
              <el-table-column label="公司名稱"  prop="ComName" min-width="30%"  >
                <template slot-scope="scope">       
                    <el-tooltip content="將開啟新頁" placement="top">
                    <a class="goDetailPage" @click="doshowDetail(scope.row)">{{ scope.row.ComName }}</a>
                    </el-tooltip>
                </template>
              </el-table-column>                                      
              <el-table-column prop="OrigRegDt" min-width="15%">
                <template slot="header">
                  <span class="sortable-header" @click="handleSort('OrigRegDt')">
                    原始登記時間
                    <i v-if="currentSortField === 'OrigRegDt'" 
                       :class="currentSortOrder === 'asc' ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
                  </span>
                </template>
                <template slot-scope="scope">
                    {{ scope.row.OrigRegDt }}
                </template> 
              </el-table-column>              
              <el-table-column prop="ApvDt" min-width="15%">
                <template slot="header">
                  <span class="sortable-header" @click="handleSort('ApvDt')">
                    核發日期
                    <i v-if="currentSortField === 'ApvDt'" 
                       :class="currentSortOrder === 'asc' ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
                  </span>
                </template>
                <template slot-scope="scope">
                    {{ scope.row.ApvDt }}
                </template> 
              </el-table-column>                                  
              <el-table-column prop="IsImport"  min-width="10%">
                <template slot="header">
                  <span class="sortable-header" @click="handleSort('IsImport')">
                    進口資格
                    <i v-if="currentSortField === 'IsImport'" 
                       :class="currentSortOrder === 'asc' ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
                  </span>
                </template>
                <template slot-scope="scope">
                    <el-button v-if="scope.row.IsImport=='有'" type="text" @click="showDrawer('import',scope.row.UniComNm)">{{ scope.row.IsImport  }}</el-button>                     
                    <span v-else>{{ scope.row.IsImport }}</span>                     
                </template>
              </el-table-column>                                        
              <el-table-column prop="IsExport"  min-width="10%">
                <template slot="header">
                  <span class="sortable-header" @click="handleSort('IsExport')">
                    出口資格
                    <i v-if="currentSortField === 'IsExport'" 
                       :class="currentSortOrder === 'asc' ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
                  </span>
                </template>
                <template slot-scope="scope">
                    <el-button v-if="scope.row.IsExport=='有'" type="text" @click="showDrawer('export',scope.row.UniComNm)">{{ scope.row.IsExport  }}</el-button> 
                    <span v-else>{{ scope.row.IsExport }}</span>
                </template>
              </el-table-column>                                        
              <el-table-column label="企業資訊"  min-width="10%"   >
                <template slot-scope="scope">                                   
                    <el-button type="text" @click="btnOpDetail(scope.row)">明細</el-button>                                
                </template>
              </el-table-column>         
                                                                 
            </el-table>                
        </div>
        <div class="pageBox">
            <Pagination
                @currentChange="pageChange"
                :maxPageLimit="50"
                :pageSize="this.listQuery.Page_Size"
                :propsCurrentPage="this.listQuery.Page_Num"
                :totalLists="totalLists">
            </Pagination>
        </div>          

        <!-- 出進口明細 drawer -->
        <el-drawer
            :title="detailDrawerTitle"
            :visible.sync="detailDrawerVisible"
            direction="rtl"
            size="40%">
            <div style="padding: 20px;">
                <el-descriptions  :column="1" :label-style="{ fontWeight: 900, width: '30%' }" size="medium" border>
                    <el-descriptions-item v-for="(item, index) in drawerDataDetail" :key="index" :label="item.label">{{ item.value }}</el-descriptions-item>                    
                </el-descriptions>
                <div style="margin-top: 20px; text-align: center;">
                    <el-button type="primary" @click="detailDrawerVisible = false">關閉</el-button>
                </div>
            </div>
        </el-drawer>

        <!-- 添加右側抓屉 (進出口實績) -->
        <el-drawer
            :title="drawerTitle"
            :visible.sync="drawerVisible"
            direction="rtl"
            size="30%">
            <div style="padding: 20px;">
                <h3>{{ drawerTitle }} 詳細資料</h3>
                <el-table :data="drawerData" stripe style="width: 100%" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" >
                    <el-table-column prop="date" label="統計年度" width="180"></el-table-column>
                    <el-table-column prop="rank" :label="drawerColumnLabel" width="180"></el-table-column>                    
                </el-table>
                <div style="margin-top: 20px; text-align: center;">
                    <el-button type="primary" @click="drawerVisible = false">關閉</el-button>
                </div>                
            </div>
        </el-drawer>        

    </div>

    
</template>

<script>
import { notify, handleError } from '@/utils/notify';
import { loadPdfFontBase64, PDF_FONT_MAX_MB } from '@/utils/pdfFontLoader';
import { drawTiledImageWatermark as drawTiledImageWatermarkUtil } from '@/utils/pdfWatermarkTiler';
import Breadcrumb from '@/components/Breadcrumb.vue';
import DistSelection from '@/components/DistSelection.vue';

export default {
    components: {DistSelection},
    data() {
        return {

            // 地區選擇相關（簡化後）
            selectedAreaValue: [],

            IsImport: "全部",
            IsExport: "全部",

            rangeDate: [],

            tableData: [],

            // 排序相關
            currentSortField: '',
            currentSortOrder: '',

            scoreList: ['全部', 'A', 'B', 'C','D','E','F'],
            
            listUsages: false,
            totalLists:0,
            lstIndusCode:[],
            lstOtherCode: [],
            DistList: [],
            inputVisible: false,
            inputValue: '',
            selectedCity: "全部",
            selCity: "全部",

            keyword: "",  
            lstQuery: [],            

            listQuery: {
                Page_Size:10,
                Page_Num:1,
                IsLatest: "Y"
            },        
            drawerDataDetail: [],
            detailDrawerVisible: false,   
            
            drawerTitle: '',
            drawerColumnLabel: '總進口實績',
            drawerData: [],
            drawerVisible: false,
            detailDrawerTitle: '',

            ioDataMapping: [
                {"key":"A","value":"A (1,000萬(含)美元以上)"},
                {"key":"B","value":"B (900萬(含)~1,000萬美元)"},
                {"key":"C","value":"C (800萬(含)~900萬美元)"},
                {"key":"D","value":"D (700萬(含)~800萬美元)"},
                {"key":"E","value":"E (600萬(含)~700萬美元)"},
                {"key":"F","value":"F (500萬(含)~600萬美元)"},
                {"key":"G","value":"G (400萬(含)~500萬美元)"},
                {"key":"H","value":"H (300萬(含)~400萬美元)"},
                {"key":"I","value":"I (200萬(含)~300萬美元)"},
                {"key":"J","value":"J (100萬(含)~200萬美元)"},
                {"key":"K","value":"K (50萬(含)~100萬美元)"},
                {"key":"L","value":"L (0萬~50萬美元以下)"},
                {"key":"M","value":"M (0萬美元)"}
            ],
        }        

        
    },
    methods: {

        async getCompanyDetail(unicomnm) {
            this.$store.dispatch("loadingHandler", true);

            const qry = {
                "Page_Size": 1,
                "Page_Num": 1,    
                "SearchText": [unicomnm]
            }            

            try {
                const res = await this.$api.apibidmain.search_bidmain(qry);
                if( res.total > 0) {                    
                    console.log("companyDetail", res.data[0]);
                    this.companyDetail = res.data[0];
                }
                else {
                    notify({
                        title: "查無公司資料",
                        message: `統一編號 ${unicomnm} 查無公司資料`,
                        type: "error"
                    });
                }

            } catch (err) {
                handleError(err, {
                    title: "錯誤",
                    message: "查詢失敗，請稍後再試",
                    type: "error"
                });
            }
            this.$store.dispatch("loadingHandler", false);
        },       
        
        doshowDetail(row) {
            console.log(row);

            this.$queryRecord(this, row.ComName, 'company');  // 記錄點擊公司名
            // 開新頁面, 轉到ctmMapCx.vue頁面
            const url = `/ctmMapCom?unicomnm=${row.UniComNm}`;
            window.open(url, '_blank');

        },        

        async showDrawer(type,selectedUniComNm) {
            // 設定抓屉標題
            this.drawerTitle = type === 'import' ? '進口實績' : '出口實績';
            this.drawerColumnLabel = type === 'import' ? '總進口實績' : '總出口實績';   
            
            await this.getCompanyDetail(selectedUniComNm);

            // 直接從 companyDetail 取得原始資料（避免依賴尚未載入的 profileList）
            const raw = type === 'import' 
                ? this.companyDetail.au_import_value 
                : this.companyDetail.au_export_value;

            console.log("raw data for drawer:", raw);
            // 正規化：支援陣列、逗號分隔字串或 JSON 字串
            let list = [];
            if (Array.isArray(raw)) {                
                // 使用 map（不是 foreach）產生表格資料
                raw.forEach(item => {
                    const datePart = item.event_date.replace("-01-01", ""); // 移除 "-01-01";    
                    const val = item.name;
                    list.push({ date: datePart || '', rank: this.resolveIoDataMappingValue(val || '') });                    
                });  
                console.log("list from array:", list);              
                // 針對年份排序, 降冪
                list.sort((a, b) => parseInt(b.date) - parseInt(a.date));

                this.drawerData = list;                
            } 


  
            
            // 顯示抓屉
            this.drawerVisible = true;
        },         

        btnOpDetail(row) {
            this.detailDrawerTitle = '出進口明細';

            //將row 資料轉成json格式    
            this.drawerDataDetail = [
                {label:"統一編號", value: row.UniComNm },
                {label:"原始登記日期", value: row.OrigRegDt },
                {label:"核發日期", value: row.ApvDt },
                {label:"廠商中文名稱", value: row.ComName },
                {label:"廠商英文名稱", value: row.ForEngComName },
                {label:"中文營業地址", value: row.ComLoc },
                {label:"英文營業地址", value: row.ENComLoc },
                {label:"代表人", value: row.RepName },
                {label:"電話號碼", value: row.PhoneNm },
                {label:"傳真號碼", value: row.FaxNm },
                {label:"資料日期", value: row.DataDt }
            ];
            this.detailDrawerVisible = true;            

            // if( ret.IsImport == "有" ) {
            //     // 有進口資格, 才有進口實績, 從 this.profileList.au_importValue 取得
            //     this.ioDataList.push({title:"進口實績", value:  ret.IsImport + "(點擊查看歷史)", clickable: true, linkType: 'import' });
            // }  
            // else {
            //     this.ioDataList.push({title:"進口實績", value: "無" });
            // }                  
            // if( ret.IsExport == "有" ) {
            //     // 有出口資格, 才有出口實績, 從 this.profileList.au_exportValue 取得
            //     this.ioDataList.push({title:"出口實績", value: ret.IsExport + "(點擊查看歷史)", clickable: true, linkType: 'export' });
            // }
            // else {
            //     this.ioDataList.push({title:"出口實績", value: "無" });
            // }


            
            
                         

        },
   


        // 處理區域變更（從子組件接收事件）
        handleAreaChange(values) {
            //console.log('父組件接收到區域變更（完整路徑）：', values);
            
            if (!values || values.length === 0) {
                this.selectedCity = "全部";
                this.selectedDistrict = "";
                delete this.listQuery.Address;
                return;
            }            

            
            // 根據選擇層級決定顯示內容
            if( values.length === 2) {

                this.listQuery.Address = values[1]; // 縣市
            }
            else if (values.length === 3) {
                const area = values[0];      // 第一層：區域
                const city = values[1];      // 第二層：縣市  
                const district = values[2];  // 第三層：區域      
                this.listQuery.Address = `${city}${district}`;                
            }
            else if (this.listQuery.Address) { // 若非三層選擇，清除地址條件
                delete this.listQuery.Address;
            }
  
            //console.log('更新後的查詢條件：', this.listQuery);
        },         

        // 串到公司詳細資訊頁... http://localhost:1200/companyDetail?comid=90699843&comname=台泥東立綠能股份有限公司
        async doShowCompanyDetail(data) {
            console.log(data);
            const comid = data.UniComNm;
            const comname = data.ComName;
            this.$queryRecord(this, comname, 'company');  // 記錄點擊公司名


            // 開啟新視窗, 顯示公司詳細資訊
            const url = `/companyDetail?comid=${comid}&comname=${comname}`;
            window.open(url, '_blank');		
            
        },        

        handleClose(tag) {
            this.lstQuery.splice(this.lstQuery.indexOf(tag), 1);              
            this.selectedCity ="全部";
            this.selCity = "全部";                  
        },         

        dashFormat: function(value) {
            
            if( value===null || value?.length!=8) 
                return "";
            else  {                
                return value.slice(0, 4) + '-' + value.slice(4, 6) + '-' + value.slice(6);
            }
        },

        showArea(payload) {
            // console.log("showArea", payload);
            if( payload.area.length > 0) {
                let txtAddress = payload.city + payload.area;
                this.listQuery.address = txtAddress;    
                // 因為只能選擇一個區域，所以先清空
                this.lstQuery = [];
                this.lstQuery.push(txtAddress);    
            }
        }, 

        handleSort(field) {
            // 如果點擊同一欄位，切換排序方向
            if (this.currentSortField === field) {
                this.currentSortOrder = this.currentSortOrder === 'asc' ? 'desc' : 'asc';
            } else {
                // 點擊新欄位，設置為升序
                this.currentSortField = field;
                this.currentSortOrder = 'asc';
            }
            
            // 重設到第一頁並查詢
            this.listQuery.Page_Num = 1;
            this.getList();
        },

        async doSearch() {        
            if( this.keyword && this.keyword.trim() !== '' )
                this.$queryRecord(this, this.keyword, 'keyword');  // 記錄搜尋關鍵字       
            this.listQuery.Page_Num = 1; // 重設回第一頁         
            await this.getList();
        },



        doClearQuery() {
            this.keyword = "";
            this.selectedAreaValue = [];
            this.rangeDate = [];
            this.IsImport = "全部";
            this.IsExport = "全部";
        },

        handleSelectionChange(val) {
            console.log("checked",val);
            this.selectData = val;
        },  
        async pageChange(val) {                
            this.listQuery.Page_Num = val;
            await this.getList();
        },  
        
        isEightDigits(str) {
            return /^\d{8}$/.test(str);
        },
        


        async getList() {
            this.$store.dispatch("loadingHandler", true);

            //console.log("Before listQuery", this.listQuery);

            if( this.keyword?.length > 0) {
                this.listQuery.SearchText = this.keyword;
            }
            else {
                delete this.listQuery.SearchText;
            }

            if( this.rangeDate &&  this.rangeDate.length == 2) {
                this.listQuery.Start_Date = this.rangeDate[0]
                this.listQuery.End_Date = this.rangeDate[1]
            }
            else {
                delete this.listQuery.Start_Date;
                delete this.listQuery.End_Date;                
            }

            if( this.IsExport!="全部" ) {
                this.listQuery.ExportQual = this.IsExport;
            }
            else {
                delete this.listQuery.ExportQual;
            }

            if( this.IsImport!="全部" ) {
                this.listQuery.ImportQual = this.IsImport;
            }
            else {
                delete this.listQuery.ImportQual;
            }

            // 添加排序參數
            if (this.currentSortField) {
                this.listQuery.SortField = this.currentSortField;
                this.listQuery.SortOrder = this.currentSortOrder;
            } else {
                delete this.listQuery.SortField;
                delete this.listQuery.SortOrder;
            }

            // console.log("listQuery", this.listQuery);


            try {
                const res = await this.$api.apidata.get_com_trade(this.listQuery);
                //console.log("res", res);
                this.tableData = res.data;
                this.totalLists = parseInt(res.total);
            } catch (err) {
                handleError(err, {
                    title: "錯誤",
                    message: "查詢失敗，請稍後再試",
                    type: "error"
                });
            }
            this.$store.dispatch("loadingHandler", false);
        },
        
        resolveIoDataMappingValue(rankKey) {
            const matchedEntry = (this.ioDataMapping || []).find(entry => entry && entry.key === rankKey);
            return matchedEntry ? (matchedEntry.value || rankKey) : rankKey;
        },

        async getBranchDist() {
            const { branchArea, branchCity, branchDist } = this.$store.state;
            
            // 只有當所有值都存在時才設置（避免 [null, null, null] 的情況）
            if (branchArea && branchCity) {
                if (branchDist) {
                    this.selectedAreaValue = [branchArea, branchCity, branchDist];
                } else {
                    this.selectedAreaValue = [branchArea, branchCity];
                }
                console.log("父組件 - 初始化選擇區域:", this.selectedAreaValue);
                
                // 等待子組件完成初始化
                await this.$nextTick();
                this.handleAreaChange(this.selectedAreaValue);
            }
        }

    },    

    async mounted() {
        this.$store.dispatch("loadingHandler", true);
        
        // 取得分公司地區，並設定地區選擇
        // await this.getBranchDist();
        
        // 再執行查詢
        await this.getList();

        this.$store.dispatch("loadingHandler", false);
    }    
}
</script>

<style lang="scss" scoped>
//  * {
//      outline: 1px solid red;
//  }

.custom1-dropdown-menu {
        max-width: 750px;
        margin-top: -30px;
        margin-left: 180px;
        display: flex;
        // justify-content: space-between;
        flex-wrap: wrap;
        max-height: 300px; /* 設置最大高度 */
        overflow-y: auto; /* 啟用垂直滾動條 */
}

.custom1-dropdown-menu > .el-dropdown-item {
    flex: 1 1 30%; /* 每行顯示兩個選項 */
    // min-width: 130px;

}  


#iodataBox {
  background: linear-gradient(-135deg, #FFF 20%, #fff 50%, transparent 50%)
    center center / 100% 100%;
  min-height: 100vh;
  padding: 0px 0%;




  .dialogBox {
    display: flex;
    flex-direction: column;;    
    justify-content: flex-start;
    padding: 0px 5%;
    .row1 {
        display: flex;
        flex-direction: row;    
        justify-content: flex-start;
        .itemBox {
            display: flex;
            flex-direction: row;    
            justify-content: flex-start;
            margin: 10px 10px;
            width: 50%;

            label {            
                margin-right: 10px;
                margin-top:10px;
                white-space: nowrap;
                font-weight: bold;
                font-size:medium;
            }
            button {
                text-align: right;
            }
        }
    }
  }


  .searchWrap   {
    display: flex;
    flex-direction: column;    
    justify-content: flex-start;
    padding: 0px 5%;
    .row {
        display: flex;
        flex-direction: row;    
        justify-content: flex-start;
        
        .itemWrap {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            margin: 5px 0px 5px 0px;     
            label {
                white-space: nowrap;
                margin-right: 10px;
                font-weight: bold;
                font-size:medium;
            }
        }
    }
    .rowTag {
        display: flex;
        flex-direction: row;    
        justify-content: flex-start;
        margin: -15px 0px 0px 140px;
        padding: 0px 5%;
        .itemWrap {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
        }
    }
  }

  .buttonBox {
    padding: 0 5%;
    display: flex;
    justify-content: center;

  }

  .content {
    display: flex;
    flex-direction: column;    
    justify-content: flex-start;
    padding: 0px 5%;
    .legend {
        display: flex;
        flex-direction: row;
        .legendItem {
            width: 80px;
            margin: 5px 10px;
        }
        
    }

  }  
  .pageBox {
    display: flex;
    flex-direction: columns;    
    justify-content: flex-end;
    padding: 0px 5%;
   }  

  .goDetailPage {
    color: #0645ad;
    text-decoration: underline;
    cursor: pointer;
   }

    // 排序標題樣式
    .sortable-header {
        cursor: pointer;
        user-select: none;
        color: #409eff; /* 預設為藍色 */

        &:hover {
            color: #409eff;
        }

        i {
            margin-left: 4px;
            font-size: 12px;
            color: #409eff;
        }
    }
}
</style>